import _extends from "@babel/runtime/helpers/extends";
import React, { useEffect } from 'react';
import { Box } from '@mui/system';
import { useSnackbar } from 'notistack';
import { Grow } from '@mui/material';
import Alert from '../Alert';

var MultipleToast = function MultipleToast(_ref) {
  var e2e = _ref.e2e,
      severity = _ref.severity,
      message = _ref.message,
      header = _ref.header,
      keyRender = _ref.keyRender,
      _ref$closeable = _ref.closeable,
      closeable = _ref$closeable === void 0 ? true : _ref$closeable,
      _ref$anchorOrigin = _ref.anchorOrigin,
      anchorOrigin = _ref$anchorOrigin === void 0 ? {
    vertical: 'top',
    horizontal: 'center'
  } : _ref$anchorOrigin,
      _ref$duration = _ref.duration,
      duration = _ref$duration === void 0 ? 4000 : _ref$duration,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'outlined' : _ref$variant,
      _ref$loading = _ref.loading,
      loading = _ref$loading === void 0 ? false : _ref$loading,
      action = _ref.action;

  var _useSnackbar = useSnackbar(),
      enqueueSnackbar = _useSnackbar.enqueueSnackbar,
      closeSnackbar = _useSnackbar.closeSnackbar;

  useEffect(function () {
    if (!message) {
      return;
    }

    enqueueSnackbar('', {
      content: /*#__PURE__*/React.createElement(Box, e2e && {
        'data-e2e': e2e
      }, /*#__PURE__*/React.createElement(Alert, _extends({}, e2e && {
        e2e: "".concat(e2e, "-alert")
      }, {
        severity: severity || 'info',
        dsOnClose: function dsOnClose() {
          return closeSnackbar(keyRender);
        },
        open: true,
        loading: loading,
        variant: variant,
        dismissible: closeable,
        body: message,
        header: header,
        action: action
      }))),
      anchorOrigin: anchorOrigin,
      autoHideDuration: duration,
      key: keyRender,
      TransitionComponent: Grow
    });
  }, [e2e, severity, message, header, keyRender, closeable, anchorOrigin, duration, variant, loading, action, enqueueSnackbar, closeSnackbar]);
  return /*#__PURE__*/React.createElement(React.Fragment, null);
};

export default MultipleToast;
//# sourceMappingURL=MultipleToast.js.map